import bitcoin from "../../images/bitcoin.png";
import dogecoin from "../../images/coin.png";
import ethereum from "../../images/ethereum.png";
import litecoin from "../../images/litecoin.png";

export const getCurrencyNameAndIcon = (currency) => {
  if (currency === "btc") {
    return {
      name: "Bitcoin",
      icon: bitcoin,
      website: "https://bitcoin.org/en/",
    };
  } else if (currency === "doge") {
    return {
      name: "DogeCoin",
      icon: dogecoin,
      website: "https://dogecoin.com/",
    };
  } else if (currency === "ltc") {
    return {
      name: "LiteCoin",
      icon: litecoin,
      website: "https://litecoin.com/en/",
    };
  } else if (currency === "eth") {
    return {
      name: "Etherium",
      icon: ethereum,
      website: "https://ethereum.org/en/",
    };
  }
};
